"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Step = _interopRequireDefault(require("@material-ui/core/Step/Step"));
var _StepContent = _interopRequireDefault(require("@material-ui/core/StepContent/StepContent"));
var _StepLabel = _interopRequireDefault(require("@material-ui/core/StepLabel/StepLabel"));
var _Stepper = _interopRequireDefault(require("@material-ui/core/Stepper"));
var _Typography = _interopRequireDefault(require("../../Typography"));
function Inline(_ref) {
  var activeStep = _ref.activeStep,
    classes = _ref.classes,
    error = _ref.error,
    orientation = _ref.orientation,
    primaryButton = _ref.primaryButton,
    secondaryButton = _ref.secondaryButton,
    stepContent = _ref.stepContent;
  return /*#__PURE__*/_react["default"].createElement(_Stepper["default"], {
    activeStep: activeStep,
    orientation: orientation,
    classes: {
      root: classes.stepRoot
    }
  }, stepContent.map(function (step, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _react["default"].createElement(_Step["default"], {
        key: "".concat(step.title, "-").concat(index)
      }, /*#__PURE__*/_react["default"].createElement(_StepLabel["default"], {
        error: error === index,
        classes: {
          iconContainer: classes.stepIcon,
          labelContainer: classes.stepLabel
        }
      }, step.stepTitle), /*#__PURE__*/_react["default"].createElement(_StepContent["default"], {
        className: classes.stepContentRoot,
        classes: {
          transition: classes.stepTransition
        }
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "h6",
        className: classes.stepContentTitle
      }, step.contentTitle), /*#__PURE__*/_react["default"].createElement("section", {
        className: classes.stepContentBody
      }, step.contentBody), /*#__PURE__*/_react["default"].createElement("section", {
        className: classes.stepActionBar
      }, secondaryButton, primaryButton)))
    );
  }));
}
Inline.propTypes = process.env.NODE_ENV !== "production" ? {
  activeStep: _propTypes["default"].number.isRequired,
  classes: _propTypes["default"].object.isRequired,
  error: _propTypes["default"].number.isRequired,
  orientation: _propTypes["default"].string.isRequired,
  primaryButton: _propTypes["default"].element,
  secondaryButton: _propTypes["default"].element,
  stepContent: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired
} : {};
var _default = Inline;
exports["default"] = _default;